import { apiInstances } from '../../../../libs';

const { get } = apiInstances.userInstance;

export const getBankListService = async () => {
  return get(`/common/banks`);
};
